export interface CaseSegmentsModel {
  segments: CaseSegmentModel[];
}

export interface CaseSegmentModel {
  mark: string;
  description: string;
}

export const caseSegmentInitialData = {
  mark: 'E-1',
  description: '',
}

export const caseSegmentsInitialData = {
  segments: []
}
